import {IFileSystemStrategy} from "./file-system.strategy.interface";
import {saveAs} from 'file-saver';

export class WebappFileSystemStrategy implements IFileSystemStrategy {
    async saveBlob(blob: Blob, fileName: string): Promise<void> {
        saveAs(blob, fileName);
    }

}